export const checkIfDateSuit = (valueDate: Date, startDate: Date): boolean => {
  const valueDateMonth = valueDate.getMonth();
  const valueDateYear = valueDate.getFullYear();
  const startDateMonth = startDate?.getMonth();
  const startDateYear = startDate?.getFullYear();

  return valueDateMonth === startDateMonth && valueDateYear === startDateYear;
};
